<template>
  <my-modal v-model:visible="visible" hideActions>
    <my-table :data="data" :headers="headers" :query="query" :editable="false">
      <template v-slot:title>
        <span class="text-red-500">Утасны дугаар дээрх асуудалтай гэрээнүүд</span>
      </template>
      <template v-slot:footer>
        <my-button @click="visible = false" icon="x">Хаах</my-button>
      </template>
    </my-table>
  </my-modal>
</template>
<script>
export default {
  props: {
    data: { type: Array, default: () => { return [[], 0] } }
  },
  data () {
    return {
      headers: [{
        name: 'regNo',
        caption: 'Гэрээний дугаар',
        width: '90px'
      }, {
        name: 'createdAt',
        caption: 'Огноо',
        type: 'Date',
        width: '120px'
      }, {
        name: 'status.name',
        caption: 'Төлөв',
        width: '140px'
      }, {
        name: 'customer.registerNum',
        caption: 'Регистрийн дугаар',
        width: '140px'
      }, {
        name: 'customer.lastName',
        caption: 'Овог'
      }, {
        name: 'customer.firstName',
        caption: 'Нэр'
      }],
      query: { page: 1, limit: 20, sort: [], search: [] }
    }
  },
  computed: {
    visible: {
      get () {
        return this.data && this.data.length > 1 && this.data[1] > 0
      },
      set () {
        this.$emit('update:data', [[], 0])
      }
    }
  }
}
</script>
